// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // ✅ Tailwind CSS included
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext'; // ✅ import this
import { WorkspaceProvider } from './WorkspaceContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <WorkspaceProvider>
          <App />
        </WorkspaceProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
